export class NameWarningItem {
  constructor(
    public nameWarning: string,
    public settingNameWarning: string,
    public isWarning: boolean
  ) {
  }
}
